"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIntent = void 0;
/**
 * Represents intents from the Answers API.
 *
 * @public
 */
var SearchIntent;
(function (SearchIntent) {
    /** The Answers API is requesting a prompt for the user's location. */
    SearchIntent["NearMe"] = "NEAR_ME";
})(SearchIntent = exports.SearchIntent || (exports.SearchIntent = {}));
